module.exports = __webpack_public_path__ + "static/empty-8dcc9dcf5e15ca92a7453859637aa01e.png";